import Section from '../ui/Section'
import { Display, Statement, Body, Points, Accent } from '../ui/Type'

const CONTROL = ['Their data', 'Their models', 'Their infrastructure', 'Their execution', 'Their geography']

const GUARANTEES = [
  {
    label: 'Enterprise isolation',
    title: 'Never trained on. Ever.',
    body: 'Your prompts, context and workload are not used to train our models.',
  },
  {
    label: 'Dedicated capacity',
    title: 'Your capacity. Your workload. Isolated execution.',
    body: 'No shared inference. No neighbors. The capacity you reserve serves your workload alone, for as long as you hold it.',
  },
  {
    label: 'Sovereign deployment',
    title: 'Private environments, as locked down as the work requires.',
    body: 'Security, region and deployment requirements are engineered around the workload.',
  },
]

export default function DataSecurity() {
  return (
    <Section id="data-security" label="Data & security">
      <Display>Your data was never ours to take.</Display>

      <Body className="mt-8">
        Your data, workflows, and context are part of your competitive advantage. They should remain that way.
      </Body>
      <Body className="mt-5">LiquidBrain is designed for organizations that need control over:</Body>
      <Points className="mt-8" cols={2} items={CONTROL} />

      <div className="mt-14">
        {GUARANTEES.map((g) => (
          <div key={g.label} className="border-t border-[var(--line)] py-8 first:pt-0">
            <div className="font-mono text-[11.5px] tracking-[0.14em] text-[var(--live)] uppercase">{g.label}</div>
            <h3 className="mt-4 text-[1.25rem] leading-[1.3] font-medium tracking-[-0.02em] text-[var(--ink)]">
              {g.title}
            </h3>
            <p className="mt-3 max-w-[52ch] text-[1.05rem] leading-[1.65] text-[var(--ink-2)]">{g.body}</p>
          </div>
        ))}
      </div>

      <Statement className="mt-[5.5rem]">
        Your intelligence <Accent>stays yours.</Accent>
      </Statement>
    </Section>
  )
}
